module.exports = __webpack_public_path__ + "img/box_pro_six_2.23cd7ed0.jpg";